var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "task_16px_active",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,-2.27373675e-13 C15.1045695,-2.27373675e-13 16,0.8954305 16,2 L16,14 C16,15.1045695 15.1045695,16 14,16 L2,16 C0.8954305,16 1.0658141e-14,15.1045695 1.0658141e-14,14 L1.0658141e-14,2 C1.0658141e-14,0.8954305 0.8954305,-2.27373675e-13 2,-2.27373675e-13 L14,-2.27373675e-13 Z M14,1.7 L2,1.7 C1.83431458,1.7 1.7,1.83431458 1.7,2 L1.7,14 C1.7,14.1656854 1.83431458,14.3 2,14.3 L14,14.3 C14.1656854,14.3 14.3,14.1656854 14.3,14 L14.3,2 C14.3,1.83431458 14.1656854,1.7 14,1.7 Z M5,3.5 C5.82842712,3.5 6.5,4.17157288 6.5,5 C6.5,5.82842712 5.82842712,6.5 5,6.5 C4.17157288,6.5 3.5,5.82842712 3.5,5 C3.5,4.17157288 4.17157288,3.5 5,3.5 Z M11,12.5 C11.8284271,12.5 12.5,11.8284271 12.5,11 C12.5,10.1715729 11.8284271,9.5 11,9.5 C10.1715729,9.5 9.5,10.1715729 9.5,11 C9.5,11.8284271 10.1715729,12.5 11,12.5 Z M13.7313873,1 L15,2.26861271 L2.26861271,15 L1,13.7313873 L13.7313873,1 Z",
    id: "Shape",
    fill: "#3368FF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.1008073bd760c02155b84e27e7e21d43.svg";
export { ForwardRef as ReactComponent };